import React from "react";
import {css} from "@emotion/react";

import {flexAbsoluteCenter} from "@pg-design/helpers-css";
import {Modal} from "@pg-design/modal-module";

import {useMyOffersFavourites} from "../../../my_offers/hooks/use_my_offers_favourites";
import {IPropertyDetail} from "../../../property/types/IPropertyDetail";
import {ISelectedPlan, useComparisonToolContext} from "../../contexts/comparison_tool_context";
import {PropertyPlanModalContent} from "./PropertyPlanModalContent";
import {PropertyPlanModalHeader} from "./PropertyPlanModalHeader";

export const PropertyPlanModal = () => {
    const {favouriteProperties} = useMyOffersFavourites();
    const {selectedPropertyPlan, selectPropertyPlan} = useComparisonToolContext();

    const selectedProperty = getSelectedPropertyDetails(favouriteProperties, selectedPropertyPlan);

    if (!selectedPropertyPlan || !selectedProperty) {
        return null;
    }

    const {propertyTableIndex} = selectedPropertyPlan;

    const onNextClick = () => {
        const nextIndex = propertyTableIndex + 1 < favouriteProperties.length ? propertyTableIndex + 1 : propertyTableIndex;

        selectPropertyPlan({
            propertyTableIndex: nextIndex,
            propertyId: favouriteProperties[nextIndex].id
        });
    };

    const onPrevClick = () => {
        const prevIndex = propertyTableIndex > 0 ? propertyTableIndex - 1 : propertyTableIndex;

        selectPropertyPlan({
            propertyTableIndex: prevIndex,
            propertyId: favouriteProperties[prevIndex].id
        });
    };

    return (
        <Modal
            fullScreen
            isOpen={Boolean(selectedPropertyPlan)}
            modalTheme="dark"
            onModalClose={() => {
                selectPropertyPlan(null);
            }}
        >
            <Modal.Header variant="bar">
                <PropertyPlanModalHeader
                    property={selectedProperty}
                    statsLabel={`${selectedPropertyPlan.propertyTableIndex + 1}/${favouriteProperties.length}`}
                    onNextClick={onNextClick}
                    onPrevClick={onPrevClick}
                />
            </Modal.Header>
            <Modal.Content>
                <div css={flexAbsoluteCenter}>
                    <div css={galleryWrapStyle}>
                        <PropertyPlanModalContent property={selectedProperty} />
                    </div>
                </div>
            </Modal.Content>
        </Modal>
    );
};

//  Utils
function getSelectedPropertyDetails(favouriteProperties: IPropertyDetail[], selectedPropertyPlan: ISelectedPlan | null) {
    if (!selectedPropertyPlan) {
        return null;
    }

    const selectedProperty = favouriteProperties.find((property: IPropertyDetail) => {
        return property.id === selectedPropertyPlan.propertyId;
    });

    if (selectedProperty) {
        return selectedProperty;
    }

    return null;
}

const galleryWrapStyle = css`
    max-width: 1000px;
`;
import React from "react";
import {css} from "@emotion/react";

import {flexAbsoluteCenter} from "@pg-design/helpers-css";
import {Modal} from "@pg-design/modal-module";

import {useMyOffersFavourites} from "../../../my_offers/hooks/use_my_offers_favourites";
import {IPropertyDetail} from "../../../property/types/IPropertyDetail";
import {ISelectedPlan, useComparisonToolContext} from "../../contexts/comparison_tool_context";
import {PropertyPlanModalContent} from "./PropertyPlanModalContent";
import {PropertyPlanModalHeader} from "./PropertyPlanModalHeader";

export const PropertyPlanModal = () => {
    const {favouriteProperties} = useMyOffersFavourites();
    const {selectedPropertyPlan, selectPropertyPlan} = useComparisonToolContext();

    const selectedProperty = getSelectedPropertyDetails(favouriteProperties, selectedPropertyPlan);

    if (!selectedPropertyPlan || !selectedProperty) {
        return null;
    }

    const {propertyTableIndex} = selectedPropertyPlan;

    const onNextClick = () => {
        const nextIndex = propertyTableIndex + 1 < favouriteProperties.length ? propertyTableIndex + 1 : propertyTableIndex;

        selectPropertyPlan({
            propertyTableIndex: nextIndex,
            propertyId: favouriteProperties[nextIndex].id
        });
    };

    const onPrevClick = () => {
        const prevIndex = propertyTableIndex > 0 ? propertyTableIndex - 1 : propertyTableIndex;

        selectPropertyPlan({
            propertyTableIndex: prevIndex,
            propertyId: favouriteProperties[prevIndex].id
        });
    };

    return (
        <Modal
            fullScreen
            isOpen={Boolean(selectedPropertyPlan)}
            modalTheme="dark"
            onModalClose={() => {
                selectPropertyPlan(null);
            }}
        >
            <Modal.Header variant="bar">
                <PropertyPlanModalHeader
                    property={selectedProperty}
                    statsLabel={`${selectedPropertyPlan.propertyTableIndex + 1}/${favouriteProperties.length}`}
                    onNextClick={onNextClick}
                    onPrevClick={onPrevClick}
                />
            </Modal.Header>
            <Modal.Content>
                <div css={flexAbsoluteCenter}>
                    <div css={galleryWrapStyle}>
                        <PropertyPlanModalContent property={selectedProperty} />
                    </div>
                </div>
            </Modal.Content>
        </Modal>
    );
};

//  Utils
function getSelectedPropertyDetails(favouriteProperties: IPropertyDetail[], selectedPropertyPlan: ISelectedPlan | null) {
    if (!selectedPropertyPlan) {
        return null;
    }

    const selectedProperty = favouriteProperties.find((property: IPropertyDetail) => {
        return property.id === selectedPropertyPlan.propertyId;
    });

    if (selectedProperty) {
        return selectedProperty;
    }

    return null;
}

const galleryWrapStyle = css`
    max-width: 1000px;
`;
